<template>
  <div>
    <div class="container container--fluid" style="padding: 0;">
      <div class="layout">
        <div class="d-flex flex-grow-1 flex-column">
          <div style="margin-left: 15px">
            <h2>
              <span>Summary of </span>
              <span style="color: #e90a7d">{{choiceOfBookie() || 'All'}} </span>
              <span v-if="selectedMeeting">{{ meeting.track }} </span>
              <span v-if="selectedRace"> Race {{ race.race_number }} </span>
              <span>{{selectedDateRange}}</span>
            </h2>
          </div>
          <header-menu :bookiesrace="bookiesrace" :items="bookies"
            style="overflow-x: auto; overflow-y: hidden; margin-left: 10px;"/>
          <div class="row flex-grow-0 row--dense">
            <div v-show="!singleDate" class="col-xl-4 col-12">
              <div class="summary-bookies">
                <div class="summary-bookmakers">
                  <v-app-bar dense color="black">
                    <v-toolbar-title style="color: white" class="float-left">
                      Bets by Bookmakers
                    </v-toolbar-title>
                  </v-app-bar>
                    <div id="chart">
                      <apexchart
                        ref="betByBookLineChart"
                        type="line"
                        height="330"
                        :options="betsByBookieOptions"
                        :series="betsByBookieSeries">
                      </apexchart>
                    </div>
                </div>
              </div>
            </div>
            <div v-show="singleDate" class="col-xl-4 col-12">
              <div class="summary-bookies">
                <div class="summary-bookmakers">
                  <v-app-bar dense color="black">
                    <v-toolbar-title style="color: white" class="float-left">
                      Bets by Bookmakers
                    </v-toolbar-title>
                  </v-app-bar>
                  <div id="chart">
                    <apexchart
                      ref="betByBookBarChart"
                      type="bar"
                      height="330"
                      :options="betsByBookieOptionsBar"
                      :series="betsByBookieSeries">
                    </apexchart>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4 col-12">
              <div class="summary-bettype">
                <v-app-bar dense color="black">
                  <v-toolbar-title style="color: white" class="float-left">
                    Number of Bets by Product
                  </v-toolbar-title>
                </v-app-bar>
                <div id="chart">
                  <apexchart
                    ref="betByProduct" type="pie" height="450" :options="betsByProductOptions"
                    :series="betsByProductSeries">
                  </apexchart>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4 col-12">
              <div class="summary-customers">
                <div class="customers-number">
                  <v-app-bar dense color="black">
                    <v-toolbar-title style="color: white" class="float-left">
                      Number of Bets by Day
                    </v-toolbar-title>
                  </v-app-bar>
                  <div id="chart">
                    <apexchart
                      ref="betsByDay"
                      type="bar"
                      height="350"
                      :options="betsByDayOptions"
                      :series="betsByDaySeries">
                    </apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!selectedBookie" class="row flex-grow-0 row--dense">
            <div class="col-md-6 col-xl-4 col-12">
              <div class="summary-bettype">
                <v-app-bar dense color="black">
                  <v-toolbar-title style="color: white" class="float-left">
                    Total $ Bet Value by Bookmaker
                  </v-toolbar-title>
                </v-app-bar>
                <div id="chart">
                  <apexchart
                    ref="betValueChart" type="pie" height="450"
                    :options="totalBookmakerValueOptions"
                    :series="totalBookmakerValueSeries">
                  </apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import numeral from 'numeral'
import { BOOKMAKER_NAMES_LOOKUP } from '../../common/constants'
// import { AppBar, SearchFilter } from '../components';
// import RaceTable, { constants } from '../components/RaceTable';
import HeaderMenu from '../HeaderMenu'
import { loaders } from '../../store'

export default {
  name: 'Summary',
  components: {
    // AppBar,
    // SearchFilter,
    // RaceTable,
    HeaderMenu
  },
  data () {
    return {
      numeral,
      isSummary: true
    }
  },
  props: {
    viewType: String
  },
  watch: {
    selectedBookie () {
      // re render charts
      // eslint-disable-next-line no-unused-expressions
      this.$refs.betValueChart.updateSeries(this.totalBookmakerValueSeries)
      // eslint-disable-next-line no-unused-expressions
      this.$refs.betValueChart.updateOptions(this.totalBookmakerValueOptions)
      // eslint-disable-next-line no-unused-expressions
      this.$refs.betByProduct.updateSeries(this.betsByProductSeries)
      // eslint-disable-next-line no-unused-expressions
      this.$refs.betByProduct.updateOptions(this.betsByProductOptions)
      // eslint-disable-next-line no-unused-expressions
      this.$refs.betByProduct.render
    },
    selectedMeeting () {
      this.fetchBookieRace()
    },
    selectedRace () {
      this.fetchBookieRace()
    }
  },
  methods: {
    ...mapActions(['setError', 'setDarkMode', 'setSelectedBookie', 'logout', 'clearSelections', 'fetchBookieRace', 'fetchBookies', 'fetchData', 'fetchMeetings', 'fetchBets', 'fetchBetsByCustomer', 'fetchBetsByType', 'fetchBookieBets', 'fetchBookieBetsDated']),
    choiceOfBookie () {
      return BOOKMAKER_NAMES_LOOKUP[this.selectedBookie]
    },
    darkMode () {
      let mode
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      if (this.darkModeST === 'light') {
        mode = 'dark'
      } else {
        mode = 'light'
      }
      this.setDarkMode(mode)
      this.$refs.betByBookLineChart.updateOptions({
        theme: {
          mode: mode
        },
        chart: {
          foreColor: mode === 'dark' ? '#f6f7f8' : '#373d3f',
          background: mode === 'light' ? '#f6f7f8' : '#373d3f'
        },
        tooltip: {
          theme: mode
        }
      })
      this.$refs.betByBookBarChart.updateOptions({
        theme: {
          mode: mode
        },
        chart: {
          foreColor: mode === 'dark' ? '#f6f7f8' : '#373d3f',
          background: mode === 'light' ? '#f6f7f8' : '#373d3f'
        },
        tooltip: {
          theme: mode
        }
      })
      this.$refs.betByProduct.updateOptions({
        theme: {
          mode: mode
        },
        chart: {
          foreColor: mode === 'dark' ? '#f6f7f8' : '#373d3f',
          background: mode === 'light' ? '#f6f7f8' : '#373d3f'
        },
        tooltip: {
          theme: mode
        }
      })
      this.$refs.betsByDay.updateOptions({
        theme: {
          mode: mode
        },
        chart: {
          foreColor: mode === 'dark' ? '#f6f7f8' : '#373d3f',
          background: mode === 'light' ? '#f6f7f8' : '#373d3f'
        },
        tooltip: {
          theme: mode
        }
      })
      this.$refs.betValueChart.updateOptions({
        theme: {
          mode: mode
        },
        chart: {
          foreColor: mode === 'dark' ? '#f6f7f8' : '#373d3f',
          background: mode === 'light' ? '#f6f7f8' : '#373d3f'
        },
        tooltip: {
          theme: mode
        }
      })
    }
  },
  computed: {
    ...mapState(['data', 'loggedIn', 'meetings', 'bets', 'bookies', 'bookiesrace', 'betsByCustomer', 'betsByType', 'betsByBookie', 'filteredBets', 'loading', 'selectedMeeting', 'selectedRace', 'selectedBookie', 'darkModeST']),
    ...mapGetters(['getSelectedRace', 'getSelections', 'getSelectedMeeting', 'getBetsByCustomer', 'getBetsByType', 'getPagination', 'getDates']),
    selectedDateRange () {
      return `${this.getDates.join(' ~ ')}`
    },
    singleDate () {
      const dates = this.getDates
      return dates[0] === dates[1]
    },
    // tableHeaders() {
    //   return constants.summaryHeaders;
    // },
    // betbacksHeaders() {
    //   return constants.betbacksHeadersSummary;
    // },
    meetingsLoading () {
      return this.loading[loaders.MEETINGS]
    },
    betsLoading () {
      return this.loading[loaders.BETS]
    },
    racesLoading () {
      return this.loading[loaders.RACES]
    },
    race () {
      return this.getSelectedRace || {}
    },
    meeting () {
      return this.getSelectedMeeting || {}
    },
    betsByCustomer () {
      return this.getBetsByCustomer || {}
    },
    runners () {
      return this.race?.runners || []
    },
    betsByProductSeries () {
      const dataseries = this?.betsByType?.map((b) => b.total)
      if (dataseries.length === 0) {
        return [1]
      }
      return dataseries
      // const dataseries = [];
      // return dataseries;
    },
    betsByProductOptions () {
      const names = this?.betsByType?.map((b) => b.type)
      const options = {
        chart: {
          type: 'pie'
        },
        noData: {
          text: undefined,
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        },
        labels: names,
        // Format the label to $
        // dataLabels: {
        //   formatter(val, opts) {
        //     return numeral(opts.w.config.series[opts.seriesIndex]).format('0.0a');
        //   },
        // },
        theme: {
          mode: this.darkModeST
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
      return options
    },
    totalBookmakerValueSeries () {
      // const allData = this.bets.map((a) => a);
      const dataseries = this?.bets?.map((b) => b.total)
      if (dataseries.length === 0) {
        return [1]
      }
      return dataseries
    },
    totalBookmakerValueOptions () {
      const names = this?.bets?.map((b) => BOOKMAKER_NAMES_LOOKUP[b.bookie])
      const options = {
        chart: {
          type: 'pie'
        },
        noData: {
          text: undefined,
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        },
        dataLabels: {
          formatter (val, opts) {
            return `$${numeral(opts.w.config.series[opts.seriesIndex]).format('0.0a')}`
          }
        },
        theme: {
          mode: this.darkModeST
        },
        labels: names,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
      return options
    },
    getBookieLength () {
      const series = ([
        {
          name: 'Bookmakers',
          data: [1]
        }
      ])
      return series
    },
    betsByBookieSeries () {
      const bookieList = new Set()
      this.betsByBookie.forEach((b) => bookieList.add(b.bookie))
      const bookie = Array.from(bookieList).map((b) => ({
        name: BOOKMAKER_NAMES_LOOKUP[b],
        data: this.betsByBookie.filter((c) => BOOKMAKER_NAMES_LOOKUP[c.bookie] ===
          BOOKMAKER_NAMES_LOOKUP[b]).map((x) => x.count || 0)
      }))
      return bookie
    },
    betsByBookieOptions () {
      const dateList = new Set()
      this.betsByBookie.forEach((b) => dateList.add(b.date))
      const dateseries = Array.from(dateList)
      const options = {
        chart: {
          height: 453,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        noData: {
          text: undefined,
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        },
        dataLabels: {
          enabled: false
        },
        theme: {
          mode: this.darkModeST
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: dateseries,
          title: {
            text: 'Date'
          }
        },
        yaxis: {
          title: {
            text: 'No. of Bets'
          }
        }
      }
      return options
    },
    betsByBookieOptionsBar () {
      const dateList = new Set()
      this.betsByBookie.forEach((b) => dateList.add(b.date))
      const dateseries = Array.from(dateList)
      const options = {
        chart: {
          height: 453,
          type: 'bar',
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        theme: {
          mode: this.darkModeST
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: dateseries,
          title: {
            text: 'Date'
          }
        },
        yaxis: {
          title: {
            text: 'No. of Bets'
          }
        }
      }
      return options
    },
    betsByDaySeries () {
      const dateList = new Set()
      this.betsByBookie.forEach((a) => dateList.add(a.date))
      const counts = Array.from(dateList).map((b) => ({
        data: this.betsByBookie.filter((c) => c.date ===
          b).map((x) => x.count || 0).reduce((x, y) => x + y, 0)
      }))
      return [{
        data: counts.map((x) => x.data)
      }]
    },
    betsByDayOptions () {
      const dateList = new Set()
      this.betsByBookie.forEach((b) => dateList.add(b.date))
      const dateseries = Array.from(dateList)
      const options = {
        chart: {
          height: 453,
          type: 'bar',
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        theme: {
          mode: this.darkModeST
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: dateseries,
          title: {
            text: 'Date'
          }
        },
        yaxis: {
          title: {
            text: 'No. of Bets'
          }
        }
      }
      return options
    }
  }
}
</script>

<style scoped>
.toolbar-title {
  float: left;
}
.toolbar-content {
  right: 50px;
}
/* .summary-page {
  background-color: #eee;
} */
.spacer {
  height: 22px;
}
.summary {
  display: grid;
  margin-right: 20px;
  grid-template-rows: auto auto auto;
  grid-template-columns: 280px auto;
  grid-template-areas:
    "leftMenu toolbar"
    "leftMenu container";
}
.toolbar {
  grid-area: toolbar;
}
.container {
  height: calc(100vh);
  overflow-y: scroll;
  overflow-x: hidden;
}
.summary-header {
  grid-area: header;
}
.summary-bettype {
  grid-area: bettype;
  box-shadow: 0 3px 10px -2px rgba(85,85,85,.08), 0 2px 20px 0 rgba(85,85,85,.06),
  0 1px 30px 0 rgba(85,85,85,.03);
  border-radius: 6px;
  background-color: white;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  height: 500px;
}
.summary-leftMenu {
  grid-area: leftMenu;
  height: 1000px;
}
.races-bet p {
  margin: 0;
}
.summary-races {
  box-shadow: 0 3px 10px -2px rgba(85,85,85,.08), 0 2px 20px 0 rgba(85,85,85,.06),
  0 1px 30px 0 rgba(85,85,85,.03);
  border-radius: 6px;
  grid-area: races;
  background-color: white;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  height: 500px;
  overflow: hidden;
}
.summary-betback {
  box-shadow: 0 3px 10px -2px rgba(85,85,85,.08), 0 2px 20px 0 rgba(85,85,85,.06),
  0 1px 30px 0 rgba(85,85,85,.03);
  border-radius: 6px;
  grid-area: races;
  background-color: white;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  height: 500px;
  overflow: hidden;
}
.summary-customers {
  box-shadow: 0 3px 10px -2px rgba(85,85,85,.08), 0 2px 20px 0 rgba(85,85,85,.06),
  0 1px 30px 0 rgba(85,85,85,.03);
  border-radius: 6px;
  grid-area: customers;
  background-color: white;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  height: 500px;
}
.summary-bookies {
  box-shadow: 0 3px 10px -2px rgba(85,85,85,.08), 0 2px 20px 0 rgba(85,85,85,.06),
  0 1px 30px 0 rgba(85,85,85,.03);
  border-radius: 6px;
  background-color: white;
  grid-area: bookies;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  height: 500px;
}
</style>
